import {Paper} from '@mui/material'
import {styled} from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import IconButton from '@mui/material/IconButton'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
const PREFIX = 'SingleDataViewerComponent'

const classes = {
  text: `${PREFIX}-text`,
  value: `${PREFIX}-value`
}

const Root = styled(Paper)(({theme}) => ({
  borderRadius: 8,
  padding: theme.spacing(2),
  height: '100vh',
  [theme.breakpoints.up('sm')]: {
    height: '145px'
  },
  textAlign: 'center',

  [`& .${classes.text}`]: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    fontSize: theme.typography.subtitle1.fontSize,
    color: theme.palette.hpBaseDarker
  },

  [`& .${classes.value}`]: {
    fontSize: theme.typography.h2.fontSize,
    fontWeight: theme.typography.fontWeightBold,
    marginTop: theme.spacing(3),
    paddingBottom: theme.spacing(1),
    color: theme.palette.hpPrimaryDark
  }
}))

const StyledDiv = styled('div')(({theme}) => ({
  backgroundColor: theme.palette.background.paper,
  borderRadius: theme.spacing(1),
  padding: theme.spacing(1.5),
  margin: theme.spacing(0.5),
  display: 'flex',
  flexDirection: 'column',
  boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
  '&.no-left-margin': {
    marginLeft: 0
  }
}))
const StyledTypographyForText = styled(Typography)(({theme}) => ({
  color: theme.palette.hpBaseDarker,
  lineHeight: theme.spacing(2),
  letterSpacing: 0.25
}))
const StyledTypographyForValue = styled(Typography, {shouldForwardProp: (prop) => prop !== 'icon'})(
  ({theme, icon}) => ({
    color: theme.palette.hpBaseDarkest,
    letterSpacing: 0.25,
    marginTop: icon ? '-4px' : '0px',
    lineHeight: 1.2
  })
)

const StyledIconButton = styled(IconButton)(() => ({
  padding: '1px',
  marginLeft: '4px'
}))

const StyledInfoOutlinedIcon = styled(InfoOutlinedIcon)(({theme}) => ({
  marginBottom: '3px',
  fontSize: theme.typography.subtitle1.fontSize,
  color: theme.palette.hpPrimary
}))

const TooltipBody = styled('div')(({theme}) => ({
  fontSize: theme.typography.subtitle1.fontSize
}))

const TooltipHeading = styled('div')(({theme}) => ({
  fontSize: theme.typography.subtitle1.fontSize,
  fontWeight: theme.typography.fontWeightBold
}))

const StyledUSPercentageTypography = styled(Typography)(({theme}) => ({
  fontWeight: theme.typography.fontWeightRegular,
  fontSize: theme.typography.subtitle2.fontSize,
  color: theme.palette.text.secondary,
  marginLeft: '8px',
  display: 'inline-block',
  marginTop: 0,
  verticalAlign: 'bottom'
}))
export {
  classes,
  Root,
  StyledDiv,
  StyledTypographyForValue,
  StyledTypographyForText,
  StyledIconButton,
  StyledInfoOutlinedIcon,
  TooltipBody,
  TooltipHeading,
  StyledUSPercentageTypography
}
